<div class="flex-row content-end">
  <button type="button" class=" btn p-0 " (click)="close()">
    <img class="cursor-pointer mr-10 mt-10" src="assets/new-assets/icons/icon-close-black.svg" alt="Close">
  </button>
</div>
<div class="flex-row p-10 mt-md-90 ">
  <video controls id="videoplayer" autoplay [poster]="data.poster" class="width-100-pr mt-md-90 " aria-label="Watch">
    <source class="d-block-md d-none" [src]="data.src" type="video/mp4">
    <track src="{{data?.caption}}"
    kind="captions"
    srclang="en"
    label="English"
    default>
    Your browser does not support the video tag.
  </video>
</div>